module.exports = __webpack_public_path__ + "img/upload_design.caade7eb.svg";